import { memo } from "react";

import { QuestionSalesTermWithTime } from "@/components/features/items/edit/_shared/ui/components/main/questions/sales-term-with-time";

import { usePlanSaleTerm } from "./hooks";

export const QuestionPlanSaleTerm = memo(() => {
	const {
		isEdited,
		hasError,

		isLimitedSale,

		saleTypeForTerm,
		onSetSaleTypeForTerm,
		saleTypeForTermOptions,

		saleStart,
		saleEnd,
		saleStartTime,
		saleEndTime,
		onSetSaleTermWithTime,

		stayableStart,
		stayableEnd,
		onSetStayableTerm,
	} = usePlanSaleTerm();

	return (
		<QuestionSalesTermWithTime
			isEdited={isEdited}
			hasError={hasError}
			isLimitedSale={isLimitedSale}
			saleTypeForTermOptions={saleTypeForTermOptions}
			saleTypeForTerm={saleTypeForTerm}
			saleStart={saleStart}
			saleEnd={saleEnd}
			saleStartTime={saleStartTime}
			saleEndTime={saleEndTime}
			stayableStart={stayableStart}
			stayableEnd={stayableEnd}
			onSetSaleTermWithTime={onSetSaleTermWithTime}
			onSetSaleTypeForTerm={onSetSaleTypeForTerm}
			onSetStayableTerm={onSetStayableTerm}
		/>
	);
});

QuestionPlanSaleTerm.displayName = "QuestionPlanSaleTerm";
